/*-----------------------------------------------------------------------------------

 Template Name:Bigdeal
 Template URI: themes.pixelstrap.com/bigdeal
 Description: This is E-commerce website
 Author: Pixelstrap
 Author URI: https://themeforest.net/user/pixelstrap

 ----------------------------------------------------------------------------------- */
// 01. Slick slider
// 02. header js
// 03.footer js
// 04. Image to background js
// 05 toggle nav
// 06 navbar mobile nav
// 07 menu js
// 08. Product page
// 09. category page
// 10. Product page Quantity Counter
// 11. filter sidebar js
// 12. Filter js
// 13. tab js
// 14. RTL & Dark Light
// 15. Add to cart
// 16.  Add to wishlist
// 17. Tap on Top
// 18. loader
// 19. add to cart sidebar js
// 20. Color Picker
// 21. Add to cart quantity Counter


(function($) {
  "use strict";
  /*=====================
     01. Slick slider
     ==========================*/
  $('.slide-1 ').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });

  $('.slide-main-1').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });
  $('.slide-hot').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });
  $('.product-offer-slide').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });
  $('.mega-deal').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });
  $('.slide-slideshow-1').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });
  $('.testimonial-1').slick({
    autoplay: false,
    autoplaySpeed: 2500,
  });
  $('.slide-1-section').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });
  $('.slide-4').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });
  $('.slide-5').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    centerPadding: '15px',
    responsive: [
      {
        breakpoint: 1470,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });
  $('.slide-6').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }

    ]
  });
  $('.slide-7').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 7,
    responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  $('.slide-10').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 10,
    slidesToScroll: 10,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8
        }
      },
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.center-product-4').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          infinite: true
        }
      },

    ]
      });
      $('.team-4').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
      {
      breakpoint: 1200,
      settings: {
      slidesToShow: 3,
      slidesToScroll: 3
      }
      },
      {
      breakpoint: 991,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2
      }
      },
      {
      breakpoint: 586,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1
      }
      }
    ]
  });

  $('.blog-slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });
  $('.blog-slide-4').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });
  $('.media-slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      },

    ]
      });
      $('.hotdeal-right-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.hotdeal-right-nav'
      });
      if ($(window).width() > 768) {
      $('.hotdeal-right-nav').slick({
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.hotdeal-right-slick',
      arrows: false,
      infinite: true,
      dots: false,
      centerMode: false,
      focusOnSelect: true
      });
      /* ================ customer templates Js ===================== */
      // show success message
      $('#ResetSuccess').removeClass('hide'); 
      }else{
      $('.hotdeal-right-nav').slick({
      vertical: false,
      verticalSwiping: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.hotdeal-right-slick',
      arrows: false,
      infinite: true,
      centerMode: false,
      dots: false,
      focusOnSelect: true,
      responsive: [
      {
      breakpoint: 576,
      settings: {
      slidesToShow: 3,
      slidesToScroll: 1
      }
      }
    ]
  });
}
 $('.hotdeal-right-slick-1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  fade: true,
  asNavFor: '.hotdeal-right-nav-1'
});
if ($(window).width() > 575) {
  $('.hotdeal-right-nav-1').slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.hotdeal-right-slick-1',
    arrows: false,
    infinite: true,
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });
}else{
  $('.hotdeal-right-nav-1').slick({
    vertical: false,
    verticalSwiping: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.hotdeal-right-slick-1',
    arrows: false,
    infinite: true,
    centerMode: false,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
}


/*=====================
     02. header js
     ==========================*/

// language  block//
$('.language-dropdown-open').slideUp();
$('.language-dropdown-click').on('click', function (){
  $('.language-dropdown-open').slideToggle()
});
$('.curroncy-dropdown-open').slideUp();
$('.curroncy-dropdown-click').on('click', function (){
  $('.curroncy-dropdown-open').slideToggle()
})
$('.pro-up').hide();
$('.mor-slide-open').slideUp();
$('.mor-slide-click').on('click', function (){
  $('.mor-slide-open').slideToggle();
  $('.pro-up').toggle();
  $('.pro-down').toggle();
})


// mobile search //
$('.search-overlay').hide();
$('.close-mobile-search').on('click', function (){
  $('.search-overlay').fadeOut();
})
$('.mobile-search').on('click', function (){
  $('.search-overlay').show();
})


/*=====================
     03.footer js
     ==========================*/
var contentwidth = jQuery(window).width();
if ((contentwidth) < '767') {
  jQuery('.footer-title h5').append('<span class="according-menu"></span>');
  jQuery('.footer-title').on('click', function () {
    jQuery('.footer-title').removeClass('active');
    jQuery('.footer-contant').slideUp('normal');
    if (jQuery(this).next().is(':hidden') == true) {
      jQuery(this).addClass('active');
      jQuery(this).next().slideDown('normal');
    }
  });
  jQuery('.footer-contant').hide();
} else {
  jQuery('.footer-contant').show();
}


/*=====================
     04. Image to background js
     ==========================*/
$(".bg-top" ).parent().addClass('b-top');
$(".bg-bottom" ).parent().addClass('b-bottom');
$(".bg-center" ).parent().addClass('b-center');
$(".bg_size_content").parent().addClass('b_size_content');
$(".bg-img" ).parent().addClass('bg-size');

jQuery('.bg-img').each(function() {

  var el = $(this),
      src = el.attr('src'),
      parent = el.parent();

  parent.css({
    'background-image': 'url(' + src + ')',
    'background-size': 'cover',
    'background-position': 'center',
    'display' : 'block'
  });

  el.hide();
});

/*=====================
     05 toggle nav
     ==========================*/
$('.toggle-nav').on('click', function () {
  $('.sm-horizontal').css("right","0px");
});
$(".mobile-back").on('click', function (){
  $('.sm-horizontal').css("right","-410px");
});

/*=====================
     06 navbar mobile nav
     ==========================*/
$('.sm-nav-btn').on('click', function () {
  $('.nav-slide').css("left","0px");
});
$(".nav-sm-back").on('click', function (){
  $('.nav-slide').css("left","-410px");
});

$('.toggle-nav-desc').on('click', function () {
  $('.desc-horizontal').css("right","0px");
});
$(".desc-back").on('click', function (){
  $('.desc-horizontal').css("right","-410px");
});

/*=====================
     07 menu js
     ==========================*/

function openNav() {
  document.getElementById("mySidenav").classList.add('open-side');
}
function closeNav() {
  document.getElementById("mySidenav").classList.remove('open-side');
}
$(function() {
  $('#main-menu').smartmenus({
    subMenusSubOffsetX: 1,
    subMenusSubOffsetY: -8
  });
  $('#sub-menu').smartmenus({
    subMenusSubOffsetX: 1,
    subMenusSubOffsetY: -8
  });
});


/*=====================
     11. filter sidebar js
     ==========================*/
$('.sidebar-popup').on('click', function(e) {
  $('.open-popup').toggleClass('open');
  $('.collection-filter').css("left","-15px");
});
$('.filter-main-btn').on('click', function(e) {
  $('.collection-filter').css("left","-15px");
});
$('.filter-back').on('click', function(e) {
  $('.collection-filter').css("left","-365px");
  $('.sidebar-popup').trigger('click');
});

$('.account-sidebar').on('click', function(e) {
  $('.dashboard-left').css("left","0");
});
$('.filter-back').on('click', function(e) {
  $('.dashboard-left').css("left","-365px");
});

$(function () {
  $(".col-grid-box").slice(0, 8).show();
  $(".loadMore").on('click', function (e) {
    e.preventDefault();
    $(".col-grid-box:hidden").slice(0, 4).slideDown();
    if ($(".col-grid-box:hidden").length == 0) {
      $(".load-more-sec").text('no more products');
    }
  });
});

/*=====================
    12. Filter js
     ==========================*/
$(".filter-button").on('click', function (){
  $(this).addClass('active').siblings('.active').removeClass('active');
  var value = $(this).attr('data-filter');
  if(value == "all")
  {
    $('.filter').show('1000');
  }
  else
  {
    $(".filter").not('.'+value).hide('3000');
    $('.filter').filter('.'+value).show('3000');
  }
});

$("#formButton").on('click', function (){
  $("#form1").toggle();
});


/*=====================
      13. Tab js
     ==========================*/
$("#tab-1").css("display", "Block");
$(".default").css("display", "Block");
$(".tabs li a").on('click', function () {
  event.preventDefault();
  $('.tab_product_slider').slick('unslick');
  $('.product-4').slick('unslick');
  $(this).parent().parent().find("li").removeClass("current");
  $(this).parent().addClass("current");
  var currunt_href = $(this).attr("href");
  $('#' + currunt_href).show();
  $(this).parent().parent().parent().find(".tab-content").not('#' + currunt_href).css("display", "none");
  $(".product-4").slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint:991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});


$("#tab-1").css("display", "Block");
$(".default").css("display", "Block");
$(".tabs li a").on('click', function () {
  event.preventDefault();
  $('.tab_product_slider').slick('unslick');
  $('.product-slide').slick('unslick');
  $(this).parent().parent().find("li").removeClass("current");
  $(this).parent().addClass("current");
  var currunt_href = $(this).attr("href");
  $('#' + currunt_href).show();
  $(this).parent().parent().parent().parent().find(".tab-content").not('#' + currunt_href).css("display", "none");
  $(".product-slide").slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint:991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// new tab
$("#tab-1").css("display", "Block");
$(".default").css("display", "Block");
$(".tabs li a").on('click', function () {
  event.preventDefault();
  $('.tab_product_slider').slick('unslick');
  $('.product-slide-6').slick('unslick');
  $('.feature_product_section').slick('unslick');
  $(this).parent().parent().find("li").removeClass("current");
  $(this).parent().addClass("current");
  var currunt_href = $(this).attr("href");
  $('#' + currunt_href).show();
  $(this).parent().parent().parent().parent().parent().parent().find(".tab-content").not('#' + currunt_href).css("display", "none");
  $(".product-slide-6").slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $(".feature_product_section").slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

});




// product-5
$("#tab-1").css("display", "Block");
$(".default").css("display", "Block");
$(".tabs li a").on('click', function () {
  event.preventDefault();
  $('.tab_product_slider').slick('unslick');
  $('.slide-5').slick('unslick');
  $(this).parent().parent().find("li").removeClass("current");
  $(this).parent().addClass("current");
  var currunt_href = $(this).attr("href");
  $('#' + currunt_href).show();
  $(this).parent().parent().parent().parent().find(".tab-content").not('#' + currunt_href).css("display", "none");
  $('.slide-5').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    centerPadding: '15px',
    responsive: [
      {
        breakpoint: 1470,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });
});
// new tab
$(".feature_product_section").slick({
  arrows: true,
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
$(".product-slide-6").slick({
  arrows: true,
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
$('.product-4').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow:2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$('.product-slide').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true
      }
    },
    {
      breakpoint: 1367,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
$('.product_4').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1430,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$('.product-6').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow:2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



/*=====================
     14. RTL & Dark Light
     ==========================*/

$('<div class="theme-pannel-main"><ul><li id="rtl_btn"><a href="javascript:void(0)" class="btn setting_btn"><span class="rtl-txt">Rtl</span></a></li><li id="ltr_btn"><a href="javascript:void(0)" class="btn setting_btn"><span class="rtl-txt">Ltr</span></a></li><li class="sidebar-btn dark-light-btn"><a href="javascript:void(0)" class="dark-light"><span class="theme-layout-version">Dark</span></a></li></ul></div> ').appendTo($('body'));
(function() {
})();
$('#ltr_btn').hide();
$("#ltr_btn").on('click', function (){
  $('body').addClass('ltr');
  $('body').removeClass('rtl');
  $('#ltr_btn').hide();
  $('#rtl_btn').show();
});
$("#rtl_btn").on('click', function (){
  $('body').addClass('rtl');
  $('body').removeClass('ltr');
  $('#rtl_btn').hide();
  $('#ltr_btn').show();
});
$(".setting_buttons li").on('click', function (){
  $(this).addClass('active').siblings().removeClass('active');
});
$(".color-picker li").on('click', function (){
  $(this).addClass('active').siblings().removeClass('active');
});   

// dark layout //
var body_event = $("body");
body_event.on("click", ".theme-layout-version" , function(){
  $(this).toggleClass('dark');
  $('body').removeClass('dark');
  if($('.theme-layout-version').hasClass('dark')){
    $('.theme-layout-version').text('Light');
    $('body').addClass('dark');
  }else{
    $('#theme-dark').remove();
    $('.theme-layout-version').text('Dark');
  }

  return false;
});

/*=====================
     17. Tap on Top
     ==========================*/
$(window).on('scroll', function() {
  if ($(this).scrollTop() > 600) {
    $('.tap-top').fadeIn();
  } else {
    $('.tap-top').fadeOut();
  }
});
$('.tap-top').on('click', function() {
  $("html, body").animate({
    scrollTop: 0
  }, 600);
  return false;
});
/*=====================
         18. loader
         ==========================*/

$('.loader-wrapper').fadeOut('slow', function() {
  $(this).remove();
});


/*=====================
     19. add to cart sidebar js
     ==========================*/
function openCart() {
  document.getElementById("cart_side").classList.add('open-side');
}
function closeCart() {
  document.getElementById("cart_side").classList.remove('open-side');
}




/*=====================
    20. Color Picker
     ==========================*/
var body_event = $("body");

/*---------   Add to cart quantity Counter   ---------*/
$("button.add-button").click(function(){
  $(this).next().addClass("open");
  $(".qty-input").val('1');
});
$('.quantity-right-plus').on('click',function(){
  //var $add_cart_btn = $(this).parents(".cart_qty").prev().trigger( "click" );
  var $qty = $(this).siblings(".qty-input");
  var currentVal = parseInt($qty.val());
  if (!isNaN(currentVal)) {
    $qty.val(currentVal + 1);
  }
});
$('.quantity-left-minus').on('click',function(){
  var $qty = $(this).siblings(".qty-input");
  var _val =  $($qty).val();
  if(_val == '1') {
    var _removeCls = $(this).parents('.cart_qty');
    $(_removeCls).removeClass("open");
  }
  var currentVal = parseInt($qty.val());
  if (!isNaN(currentVal) && currentVal > 0) {
    $qty.val(currentVal - 1);
  }
});


/*---------   Quantity Counter   ---------*/
$('.product-description .quantity-right-plus').on('click', function () {
  var $qty = $('.qty-box .input-number');
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal + 1);
  }
});

$('.product-description .quantity-left-minus').on('click', function () {
  var $qty = $('.qty-box .input-number');
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
  }
});

})(jQuery);

function openCart() {
  document.getElementById("cart_side").classList.add('open-side');
}
function closeCart() {
  document.getElementById("cart_side").classList.remove('open-side');
}
function openAccount() {
  document.getElementById("myAccount").classList.add('open-side');
}
function closeAccount() {
  document.getElementById("myAccount").classList.remove('open-side');
}

function openWishlist() {
  document.getElementById("wishlist_side").classList.add('open-side');
}
function closeWishlist() {
  document.getElementById("wishlist_side").classList.remove('open-side');
}
function openSetting() {
  document.getElementById("mySetting").classList.add('open-side');
}
function closeSetting() {
  document.getElementById("mySetting").classList.remove('open-side');
}

$(".toggle-nav").click(function(){
  $('.sm-horizontal').css("right","0px");
  $('.sm-horizontal').css("left","unset");
});
$(".mobile-back").click(function(){
  $('.sm-horizontal').css("left","-410px");
  $('.sm-horizontal').css("right","unset");
});

$('#cart_side .close-cart, #cart_side .overlay').on('click', function(e) {
  $('#cart_side').removeClass('open-side');
});

$( document ).ready(function() {
  $('#RecoverPassword').on('click', function(evt) {
    console.log('click');
    evt.preventDefault();
    toggleRecoverPasswordForm();$('#RecoverPasswordForm').toggleClass();
  });

  $('#HideRecoverPasswordLink').on('click', function(evt) {
    console.log('click');
    evt.preventDefault();
    toggleRecoverPasswordForm();
  });

  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  var hash = window.location.hash;
  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }

  var $formState = $('.reset-password-success');
  // check if reset password form was successfully submited.
  if (!$formState.length) {
    return;
  }
  // show success message
  $('#ResetSuccess').removeClass('hide');   
});

window.theme = theme || {};




window.theme = theme || {};

theme.customerTemplates = (function() {

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    if (Shopify) {
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  return {
    init: function() {
      customerAddressForm();
    }
  };
})();

theme.init = function() {
  theme.customerTemplates.init();
};

$(theme.init);

